import script from "./CategoriesHome.component.vue?vue&type=script&setup=true&lang=js"
export * from "./CategoriesHome.component.vue?vue&type=script&setup=true&lang=js"

import "./CategoriesHome.component.vue?vue&type=style&index=0&id=1ef8692e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ef8692e"]])

export default __exports__